import Header from "./Header";
import Footer from "./Footer";

import logo from "../../icon.ico"
import golf from "../../Photos/golf_outing.jpg"

// import youth from "../youth.jpg";
// import flyer from "../Photos/Bridge 127_ Golf Tournament 2024 at Schuylkill CC 2.avif"

import {ChevronRightIcon} from "@heroicons/react/16/solid";
import {Button} from "@headlessui/react";

const Activities = () => {

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = '/GolfOuting2026.pdf'; // Put your PDF path here (e.g., public/example.pdf)
        link.download = '2026_Outing_Flyer.pdf';
        link.click();
    };


    return (
        <div className="bg-white h-screen">
            {/* Header */}
            <Header/>

            <main className="isolate mb-10">

                {/*Landing*/}
                <div className="relative isolate overflow-hidden bg-white">
                    <svg
                        aria-hidden="true"
                        className="absolute inset-0 -z-10 size-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
                    >
                        <defs>
                            <pattern
                                x="50%"
                                y={-1}
                                id="0787a7c5-978c-4f66-83c7-11c213f99cb7"
                                width={200}
                                height={200}
                                patternUnits="userSpaceOnUse"
                            >
                                <path d="M.5 200V.5H200" fill="none"/>
                            </pattern>
                        </defs>
                        <rect fill="url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)" width="100%" height="100%"
                              strokeWidth={0}/>
                    </svg>
                    <div className="mx-auto max-w-7xl px-6 pb-24 pt-10 sm:pb-32 lg:flex lg:px-8 lg:py-40">
                        <div className="animate-slideInLeft mx-auto max-w-2xl lg:mx-0 lg:shrink-0 lg:pt-8">
                            <img
                                alt="Your Company"
                                src={logo}
                                className="h-11"
                            />
                            <div className="mt-24 sm:mt-32 lg:mt-16">
                                <a href="https://app.aplos.com/aws/events/2026_drive_for_hope?_gl=1*1hplkcj*_gcl_au*Njc4ODUzMjE2LjE3ODQzOTQ4OTA.*_ga*NzIyNTM2NTk2LjE3ODQzOTQ4OTE.*_ga_8610K921MT*czE3ODQ4NDY3MzkkbzUkZzEkdDE3ODQ4NTIyMTAkajQyJGwxJGg0NzA4NDY0MzE"
                                   className="inline-flex space-x-6">
                                  <span
                                      className="rounded-full bg-blue-600/10 px-3 py-1 text-sm/6 font-semibold text-blue-600 ring-1 ring-inset ring-indigo-600/10">
                                    What's upcoming!
                                  </span>
                                    <span
                                        className="inline-flex items-center space-x-2 text-sm/6 font-medium text-gray-600">
                                    <span>Sept. 23rd 2026</span>
                                    <ChevronRightIcon aria-hidden="true" className="size-5 text-gray-400"/>
                                  </span>
                                </a>
                            </div>
                            <h1 className="mt-10 text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                                Join us for out Annual Golf Outing
                            </h1>
                            <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
                                Our annual golf tournament registration is now active. Spots are limited. Register below
                                by clicking the link.
                            </p>
                            <div className="mt-10 flex items-center gap-x-6">
                                <Button
                                    onClick={handleDownload}
                                    // href="https://app.aplos.com/aws/events/2024_drive_for_hope"
                                    className="rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Download Flyer
                                </Button>
                                <a href="https://app.aplos.com/aws/events/2026_drive_for_hope?_gl=1*1hplkcj*_gcl_au*Njc4ODUzMjE2LjE3ODQzOTQ4OTA.*_ga*NzIyNTM2NTk2LjE3ODQzOTQ4OTE.*_ga_8610K921MT*czE3ODQ4NDY3MzkkbzUkZzEkdDE3ODQ4NTIyMTAkajQyJGwxJGg0NzA4NDY0MzE" className="text-sm/6 font-semibold text-gray-900">
                                    Register <span aria-hidden="true">→</span>
                                </a>
                                {/*<a href="/about-us" className="text-sm/6 font-semibold text-gray-900">*/}
                                {/*    Learn more <span aria-hidden="true">→</span>*/}
                                {/*</a>*/}
                            </div>
                        </div>
                        <div className="animate-slideInRight mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
                            <div className="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
                                <div
                                    className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">
                                    <img
                                        alt="App screenshot"
                                        src={golf}
                                        width={2432}
                                        height={1442}
                                        className="w-[76rem] rounded-md shadow-2xl ring-1 ring-gray-900/10"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Gallery*/}
                <div className={`hidden mr-16 ml-16 bg-white rounded-lg shadow-skyBlue shadow-2xl border p-2`}>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div className="grid gap-4">
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-1.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-2.jpg" alt=""/>
                            </div>
                        </div>
                        <div className="grid gap-4">
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-3.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-4.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-5.jpg" alt=""/>
                            </div>
                        </div>
                        <div className="grid gap-4">
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-6.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-7.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-8.jpg" alt=""/>
                            </div>
                        </div>
                        <div className="grid gap-4">
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-9.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-10.jpg" alt=""/>
                            </div>
                            <div>
                                <img className="h-auto max-w-full rounded-lg"
                                     src="https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-11.jpg" alt=""/>
                            </div>
                        </div>
                    </div>

                </div>

            </main>

            {/* Footer */}
            <Footer/>

        </div>
    )
};

export default Activities;
